import React, { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../components/ui/dialog";
import { Button } from "../components/ui/button";
import { toast } from "../components/ui/sonner";
import { MessageSquare, Loader2, Send } from "lucide-react";

/* 一键短信提醒分包商（从未登录 / 询价超期未回）：发送前可编辑预览 */
export function SubNudgeDialog({ target, zh, api, onClose, onSent }) {
  const [p, setP] = useState(null);
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    if (!target) return;
    setP(null);
    api.post("/auth/impersonate/nudge", { username: target.username, dryRun: true }).then(({ data }) => { setP(data); setText(data.text); }).catch((e) => toast.error(e?.detailText || e.message));
  }, [target, api]);
  const send = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/auth/impersonate/nudge", { username: target.username, dryRun: false, text });
      toast.success(zh ? `短信已发送到 ${data.to}` : `Sent to ${data.to}`);
      onSent?.(); onClose();
    } catch (e) { toast.error(e?.response?.data?.detail || e.message); }
    setBusy(false);
  };
  return (
    <Dialog open={!!target} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-lg" data-testid="sub-nudge-dialog">
        <DialogHeader><DialogTitle className="flex items-center gap-2 text-base"><MessageSquare className="h-4 w-4 text-brand-600" />{zh ? "短信提醒分包商" : "Text the subcontractor"} · {target?.companyName || target?.username}</DialogTitle></DialogHeader>
        {!p ? <div className="py-8 flex justify-center text-slate-400"><Loader2 className="h-6 w-6 animate-spin" /></div> : (
          <div className="space-y-3 text-sm">
            <div className="flex flex-wrap gap-1.5 text-[11px]">
              {p.health?.includes("never_login") && <span className="px-2 py-0.5 rounded-full bg-red-50 text-red-700 border border-red-200">{zh ? "从未登录" : "never logged in"}</span>}
              {p.pendingRfqs > 0 && <span className="px-2 py-0.5 rounded-full bg-amber-50 text-amber-700 border border-amber-200">{zh ? `待回复询价 ${p.pendingRfqs}` : `${p.pendingRfqs} RFQs pending`}</span>}
            </div>
            <p className="text-xs text-slate-500">{zh ? "收件人" : "To"}: <b data-testid="sub-nudge-to">{p.to || (zh ? "（未登记电话，无法发送）" : "(no phone on file)")}</b>{!p.smsConfigured && <span className="text-red-600 ml-2">{zh ? "短信服务未配置" : "SMS not configured"}</span>}</p>
            <textarea value={text} onChange={(e) => setText(e.target.value)} rows={5} className="w-full rounded-lg border border-slate-200 px-3 py-2 text-sm" data-testid="sub-nudge-text" />
            <p className="text-[11px] text-slate-400">{text.length} {zh ? "字符 · 发送前可修改；发送记录进入审计日志" : "chars · editable; logged to audit"}</p>
            <div className="flex justify-end gap-2">
              <Button variant="outline" size="sm" onClick={onClose} data-testid="sub-nudge-cancel">{zh ? "取消" : "Cancel"}</Button>
              <Button size="sm" className="bg-brand-600 hover:bg-brand-700 text-white" disabled={busy || !p.to || !p.smsConfigured || !text.trim()} onClick={send} data-testid="sub-nudge-send">{busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <><Send className="h-3.5 w-3.5 mr-1" />{zh ? "确认发送" : "Send"}</>}</Button>
            </div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
